import { jsx } from 'react/jsx-runtime';
import { EventLogger } from '../EventLogger.mjs';
import { EventFeatureBoundaryContext } from './eventFeatureBoundaryContext.mjs';
export { useEventFeatureBoundary } from './eventFeatureBoundaryContext.mjs';

const EventFeatureBoundary = ({
  eventFeature,
  children,
  viewProps,
  viewOnRender = true
}) => {
  return /* @__PURE__ */ jsx(EventFeatureBoundaryContext, { eventFeature, children: viewOnRender ? /* @__PURE__ */ jsx(EventLogger.View, { ...viewProps, children }) : children });
};

export { EventFeatureBoundary };
//# sourceMappingURL=eventFeatureBoundary.mjs.map
